// The API expects the axios 0.x query format: arrays become `key[]` with
// objects JSON.stringify'd (`search[]={"field":"task"}`). Axios 1.x defaults to
// bracket notation (`search[0][field]=task`), so restore the legacy behaviour.
const encodeLegacy = (value: string) =>
  encodeURIComponent(value)
    .replace(/%40/gi, "@")
    .replace(/%3A/gi, ":")
    .replace(/%24/g, "$")
    .replace(/%2C/gi, ",")
    .replace(/%20/g, "+")
    .replace(/%5B/gi, "[")
    .replace(/%5D/gi, "]");

export const legacyParamsSerializer = (params: Record<string, any>): string => {
  const parts: string[] = [];

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || typeof value === "undefined") {
      return;
    }

    const isArray = Array.isArray(value);
    const values = isArray ? value : [value];
    const encodedKey = encodeLegacy(isArray ? `${key}[]` : key);

    values.forEach((item) => {
      let serialized = item;
      if (Object.prototype.toString.call(item) === "[object Date]") {
        serialized = (item as Date).toISOString();
      } else if (typeof item === "object" && item !== null) {
        serialized = JSON.stringify(item);
      }
      parts.push(`${encodedKey}=${encodeLegacy(String(serialized))}`);
    });
  });

  return parts.join("&");
};
